module.exports = {
	"commitCount": 5,
	"commitMembers": [
		{
			"count": 1,
			"authorName": "黄涛"
		},
		{
			"count": 4,
			"authorName": "airyland"
		}
	],
	"commitUniqueCount": 2
};


//////////////////
// WEBPACK FOOTER
// ./zh-CN/components/v-chart_git_metas.json
// module id = 3128
// module chunks = 21